import React from 'react';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function TemplateInfoComponent({ isAttachment, mediaFiles, handleFormAttachmentItemChange, changeImage, selectedTemplate, handleInnerFormChange }: any) {
  const libraryData = useSelector(selectListItems)

  return (
    <>
      <AccordionContainer
        child={
          <div>
            <MediaInfoComponent
              changeImage={changeImage}
              fileTypes={libraryData?.result?.FileType}
              onFormItemChange={handleFormAttachmentItemChange}
              mediaFiles={mediaFiles}
            />
          </div>
        }
        expandedPanel=" Media"
        headerTitle="Media Info"
      />

      {!isAttachment && <div className="col-span-full">
        <InputContainer
          label="Body Content"
          name="BodyContent"
          onValueChange={(event: any) => {
            handleInnerFormChange(event, 'BodyContent');
          }}
          type="rte"
          value={selectedTemplate?.BodyContent}
        />
      </div>}
    </>
  );
}